export default () => window.innerWidth <= 768;




/** WEBPACK FOOTER **
 ** ./src/utils/isMobile.js
 **/